import { render, staticRenderFns } from "./CaseInvoices.vue?vue&type=template&id=2043495d&"
import script from "./CaseInvoices.vue?vue&type=script&lang=js&"
export * from "./CaseInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports